import React from 'react';
import { Link } from 'react-router-dom';

import HomeInsuranceCard from '../../cards/HomeInsuranceCard/HomeInsuranceCard';

import albertaBlueCrossLogo from '../../../../images/main/insurance/alberta-blue-cross.png';
import benevaLogo from '../../../../images/main/insurance/beneva.png';
import blueCrossLogo from '../../../../images/main/insurance/blue-cross.png';
import canadaLifeLogo from '../../../../images/main/insurance/canada-life.png';
import chamberPlanLogo from '../../../../images/main/insurance/chamber-of-commerce-group-insurance-plan.png';
import claimsecureLogo from '../../../../images/main/insurance/claimsecure.png';
import cowanLogo from '../../../../images/main/insurance/cowan.png';
import desjardinsLogo from '../../../../images/main/insurance/desjardins.png';
import equitableLifeLogo from '../../../../images/main/insurance/equitable-life.png';
import greenShieldLogo from '../../../../images/main/insurance/green-shield.png';
import groupHealthLogo from '../../../../images/main/insurance/group-health.png';
import groupSourceLogo from '../../../../images/main/insurance/group-source.png';
import iaFinancialGroupLogo from '../../../../images/main/insurance/ia-financial-group.png';
import johnsonLogo from '../../../../images/main/insurance/johnson.png';
import johnstonGroupLogo from '../../../../images/main/insurance/johnston-group.png';
import LIUNALogo from '../../../../images/main/insurance/labours-international-union-of-na.png';
import LIUTLogo from '../../../../images/main/insurance/labours-international-union-toronto.png';
import manionLogo from '../../../../images/main/insurance/manion.png';
import manulifeLogo from '../../../../images/main/insurance/manulife.png';
import rwamLogo from '../../../../images/main/insurance/rwam.png';
import sunLifeLogo from '../../../../images/main/insurance/sun-life.png';

import './HomeInsurance.css';

const HomeInsurance = () => {
  const insuranceLogos = [
    { src: benevaLogo, alt: 'beneva logo' },
    { src: blueCrossLogo, alt: 'blue cross logo' },
    { src: albertaBlueCrossLogo, alt: 'alberta blue cross logo' },
    { src: canadaLifeLogo, alt: 'canada life logo' },
    {
      src: chamberPlanLogo,
      alt: 'chamber of commerce group insurance plan logo',
    },
    { src: claimsecureLogo, alt: 'claimsecure logo' },
    { src: cowanLogo, alt: 'cowan logo' },
    { src: desjardinsLogo, alt: 'desjardins logo' },
    { src: equitableLifeLogo, alt: 'equitable life logo' },
    { src: greenShieldLogo, alt: 'green shield logo' },
    { src: groupHealthLogo, alt: 'group health logo' },
    { src: groupSourceLogo, alt: 'group source logo' },
    { src: iaFinancialGroupLogo, alt: 'ia financial group logo' },
    { src: johnsonLogo, alt: 'johnson logo' },
    { src: johnstonGroupLogo, alt: 'johnston group logo' },
    {
      src: LIUNALogo,
      alt: 'labours international union of north america logo',
    },
    { src: LIUTLogo, alt: 'labours international union toronto logo' },
    { src: manionLogo, alt: 'manion logo' },
    { src: manulifeLogo, alt: 'manulife logo' },
    { src: rwamLogo, alt: 'rwam logo' },
    { src: sunLifeLogo, alt: 'sunlife logo' },
  ];

  const insuranceLogosEls = [...insuranceLogos, ...insuranceLogos].map(
    ({ src, alt }, i) => {
      return <HomeInsuranceCard key={i} src={src} alt={alt} />;
    }
  );

  return (
    <div className='home-insurance-container'>
      <div className='home-insurance-text-container'>
        <p className='home-insurance-text'>
          Our clinic is affiliated with: Telus, Sunlife, etc., <br />
          and we offer direct billing through the following insurance providers.
        </p>
      </div>
      <Link
        to='/rates#direct-billing'
        className='home-insurance-cards-link'
        aria-label='Go to billing page'
      >
        <div className='home-insurance-cards-carousel'>
          <div className='home-insurance-cards-track'>{insuranceLogosEls}</div>
        </div>
      </Link>
    </div>
  );
};

export default HomeInsurance;
